export const PER_PAGE_OPTIONS = [500, 50, 20, 10];

export const MAX_EXACT_TOTAL_OPTION = 50;

export const getPerPageOptions = (total) => {
  const count = Number(total);
  const options = PER_PAGE_OPTIONS.filter((option) => option <= count);

  if (!options.length) return [Math.min(...PER_PAGE_OPTIONS)];

  const fitsInOnePage =
    count <= MAX_EXACT_TOTAL_OPTION && !PER_PAGE_OPTIONS.includes(count);

  return fitsInOnePage ? [count, ...options] : options;
};
